import React, { Suspense } from "react";
import { CloseIcon } from "../../../assets/Icons";
import "./modal.scss";

type ModalProps = {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  className?: string;
};

const Modal: React.FC<ModalProps> = ({ title, children, isOpen, onClose, className }) => {
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${className || ''}`} onClick={onClose}>
      <div className={`modal-container`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <button className="modal-close" onClick={onClose}>
            <Suspense fallback={null}>
              <CloseIcon width={24} height={24} />
            </Suspense>
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
